var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"year-line__wrapper",class:{ right: _vm.position === 'right' }},[_c('div',{staticClass:"year-line__container"},[_c('span',{staticClass:"year-line__container_year"},[_vm._v(_vm._s(_vm.year))]),_c('div',{staticClass:"year-line__container_point"}),_c('div',{staticClass:"year-line__container_vertical-line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }